import JourneyOne from "./JourneyOne";
import Characters from "./Characters";
import LandingPage from "./LandingPage";
import IntroTemplate from "./IntroTemplate";
import BenefitsTemplate from "./BenefitsTemplate";
import EndTemplate from "./EndTemplate";
import JourneyTwo from "./JourneyTwo";
import VideoJourney from "./VideoJourney";
import UseCasesTemplate from "./UseCasesTemplate";
import FullScreenVideoTemplate from "./FullScreenVideoTemplate";

interface TemplateProps<T extends keyof TemplateDataMap> {
  type: T;
  data: TemplateDataMap[T];
}

const Template = <T extends keyof TemplateDataMap>(props: TemplateProps<T>) => {
  const { type, data } = props;

  const templates: { [key: string]: any } = {
    "video-journey-template": <VideoJourney data={data as DataVideoJourney} />,
    "journey-one-template": <JourneyOne data={data as DataJourneyOne} />,
    "journey-two-template": <JourneyTwo data={data as DataJourneyTwo} />,
    "characters-template": <Characters data={data as DataCharacters} />,
    "landing-page-template": <LandingPage data={data as DataLandingPage} />,
    "intro-template": <IntroTemplate data={data as DataIntroTemplate} />,
    "benefits-template": (
      <BenefitsTemplate data={data as DataBenefitsTemplate} />
    ),
    "end-template": <EndTemplate data={data as DataEndTemplate} />,
    "use-cases-template": <UseCasesTemplate data={data as DataUseCases} />,
    "full-screen-video-template": (
      <FullScreenVideoTemplate data={data as DataFullScreenVideoTemplate} />
    ),
  };

  return <div style={{ position: "relative" }}>{templates[type]}</div>;
};

export default Template;
